import React, { useEffect, useMemo, useState } from "react";
import { useHistory, useLocation, withRouter } from "react-router-dom";

import { Event, EventTracker } from "../../../tracking/service/EventTracker/EventTrackerService";
import { useProgressPercentEffect } from "../Common/hooks/useProgressPercentEffect";
import { useRedirect } from "../Common/hooks/useRedirect";
import { useRegistrationContext } from "../Common/registrationContext";
import { useRegistrationVetPreferencesForm } from "../Common/registrationState";
import { REGISTRATION_PROGRESS_PERCENT } from "../Common/service";
import { RegistrationPageContainer } from "../RegistrationPageContainer/RegistrationPageContainer";

import { RegistrationVetPreferencesForm } from "./RegistrationVetPreferencesForm";
import { FormProvider } from "./RegistrationVetPreferencesFormContext";
import { useSave, useValidate } from "./service";

const VetPreferences = () => {
  const registrationVetPreferencesForm = useRegistrationVetPreferencesForm();
  const { save } = useSave();
  const { validate } = useValidate();
  const { redirectToWhyAreYouOnRoo } = useRedirect();
  useProgressPercentEffect(REGISTRATION_PROGRESS_PERCENT.VetPreferences);

  const location = useLocation();
  const history = useHistory();
  const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);

  const [highCommitment] = useState(() => {
    const paramValue = searchParams.get("hc") === "true";
    return paramValue;
  });

  const {
    registrationContext: { entityId },
  } = useRegistrationContext();

  useEffect(() => {
    // Clear the 'hc' param from the URL
    if (searchParams.has("hc")) {
      searchParams.delete("hc");
      history.replace({
        ...location,
        search: searchParams.toString(),
      });
    }

    EventTracker.send({
      eventName: Event.Name.VET_VIEW_VET_PREFERENCES,
      eventType: Event.Type.PAGE_VIEW,
      entityType: Event.Entity.VET,
      entityId: entityId,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const linkProps = { children: "Back to Roo Goals", onClick: redirectToWhyAreYouOnRoo };
  return (
    <RegistrationPageContainer linkProps={linkProps}>
      <FormProvider defaultForm={registrationVetPreferencesForm} save={save} validate={validate}>
        <RegistrationVetPreferencesForm highCommitment={highCommitment} />
      </FormProvider>
    </RegistrationPageContainer>
  );
};

export const RegistrationVetPreferences = withRouter(VetPreferences);
